module.exports = __webpack_public_path__ + "img/edit.89726652.svg";